module.exports = __webpack_public_path__ + "static/media/12-5.ddf854d3.mp3";